
export default {
  submitText: '提交',
  submitBtn: false,
  emptyBtn: false,
  labelWidth: 120,
  column: [],
  group: [
    {
        column: [
          {
            label: "项目名称",
            prop: "projectId",
            cascaderItem: ['userIds'],
            disabled:true,
            type: 'tree',
            dicUrl: '/api/v4ward/project/getProjectList',
            props: {label: 'name', value: 'id'},
          },
          {
            label: "计划名称",
            prop: "name",
            disabled:true,
          },

          {
            label: "合格比例(%)",
            prop: "criterionScore",
            disabled:true,
          },
          {
            label: "计算类型",
            prop: "calculateType",
            type: 'select',
            dataType: 'number',
            disabled:true,
            dicUrl: 'api/blade-system/dict/dictionary?code=calculate_type',
            props: { label: 'dictValue', value: 'dictKey' },
          },

          {
            label: "填报类型",
            prop: "informantType",
            type: 'radio',
            dataType: 'number',
            disabled:true,
            dicUrl: 'api/blade-system/dict/dictionary?code=informant_type',
            props: { label: 'dictValue', value: 'dictKey' },
          },
          {
            label: "填报对象",
            prop: "userIds",
            type: "tree",
            multiple:true,
            display: false,
            disabled:true,
            span: 24,
            row: 4,
            dicUrl: '/api/v4ward/user/project-user-list?projectId={{projectId}}',
            props: { label: 'realName', value: 'id' },
          },
          {
            label: "填报对象",
            prop: "deptIds",
            type: 'tree',
            multiple:true,
            disabled:true,
            span: 24,
            row: 4,
            display: false,
            dicUrl: 'api/v4ward/dept/treeByIds',
            props: { label: 'title', value: 'key' },
          },

          {
            prop: 'test',
            label: '题目内容',
            formslot: true,
            labelslot: true,
            span: 24,
            row:true,
          },
        ]
    },
  ],
};
